
export const timeslotToDateString = (timeslot: { start_date: string | Date; end_date: string | Date | null } | null) => {
  if (!timeslot) return null;

  const locale = "nl-NL";
  const options: Intl.DateTimeFormatOptions = {
    timeZone: "Europe/Amsterdam",
    dateStyle: "medium",
    timeStyle: "short",
  };

  const start = new Date(timeslot.start_date);
  const startString = start.toLocaleString(locale, options);
  if (!timeslot.end_date) return startString;

  const end = new Date(timeslot.end_date);
  if (end.getTime() - start.getTime() < 24 * 60 * 60 * 1000) {
    const timeOnly: Intl.DateTimeFormatOptions = {
      timeZone: options.timeZone,
      timeStyle: options.timeStyle,
    };
    return `${startString} - ${end.toLocaleTimeString(locale, timeOnly)}`;
  }
  return `${startString} - ${end.toLocaleString(locale, options)}`;
};